import env from '../config/env';

const GA_ID = env.GA_ID;
const GA_ID_PATTERN = /^G-[A-Z0-9]+$/i;

/**
 * Initialize GA4 by injecting the gtag script.
 * Called once on app mount.
 */
export function initGA() {
    if (!GA_ID || !GA_ID_PATTERN.test(GA_ID) || typeof window === 'undefined') return;

    // Avoid double-injection
    if (document.getElementById('ga-script')) return;

    const script = document.createElement('script');
    script.id = 'ga-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID, {
        send_page_view: true,
    });
}

/**
 * Track a page view (call on route change).
 */
export function trackPageView(path) {
    if (!GA_ID || !window.gtag) return;
    window.gtag('config', GA_ID, { page_path: path });
}

/**
 * Track a custom event.
 * @param {string} eventName - e.g. 'click_herramienta', 'calcular_resultado'
 * @param {object} params - additional event parameters
 */
export function trackEvent(eventName, params = {}) {
    if (!GA_ID || !window.gtag) return;
    window.gtag('event', eventName, params);
}

// Pre-defined events for convenience
export const GA_EVENTS = {
    CLICK_HERRAMIENTA: 'click_herramienta',
    CALCULAR_RESULTADO: 'calcular_resultado',
    CLICK_CTA_SERVICIO: 'click_cta_servicio',
    CLICK_WHATSAPP: 'click_whatsapp',
    SUBMIT_FORMULARIO: 'submit_formulario',
    INICIAR_CALCULADORA: 'iniciar_calculadora',
    LEAD_REGISTRADO: 'lead_registrado',
    CLICK_RESERVAR_LLAMADA: 'click_reservar_llamada',
    CLICK_BLOG: 'click_blog',
    INTERACCION_COMPARADOR: 'interaccion_comparador',
};
